import * as React from "react";
import ReactTable from "react-table";
import { FiltroConsultaHistoricoMsj, HistoricoMensaje } from "../modelo/ReporteHistoricoModelo";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";

export default class TablaHistoricoMensajes extends React.Component<TablaHistoricoMensajesProps, any> {

    columns = [
        {
            id: "nombreServicio",
            Header: "Servicio",
            accessor: "nombreServicio",
            width: 130
        }, {
            id: "poliza",
            Header: "Poliza",
            accessor: "poliza",
            width: 90
        }, {
            id: "dniEmpleador",
            Header: "Dni",
            accessor: "dniEmpleador",
            width: 90
        }, {
            id: "mensajeOriginal",
            Header: "Mensaje",
            accessor: "mensajeOriginal",
            Cell: props => this.renderDetalleJson(props, props.original.mensajeOriginal, "Mensaje Igreso Sistema"),
            width: 70
        }, {
            id: "mensajeEnvioSAT",
            Header: "Envio",
            accessor: "mensajeEnvioSAT",
            Cell: props => this.renderDetalleJson(props, props.original.mensajeEnvioSAT, "Mensaje Envio SAT"),
            width: 70
        }, {
            id: "mensajeRespuestaSAT",
            Header: "Respuesta",
            accessor: "mensajeRespuestaSAT",
            Cell: props => this.renderDetalleJson(props, props.original.mensajeRespuestaSAT, "Mensaje Respuesta SAT"),
            width: 80
        }, {
            id: "fechaMensajeoriginal",
            Header: "Fecha Mensaje",
            accessor: "fechaMensajeoriginal",
            width: 110
        }, {
            id: "fechaMensajeEnvioSAT",
            Header: "Fecha Envio",
            accessor: "fechaMensajeEnvioSAT",
            width: 110
        }, {
            id: "fechaMensajeRespuestaSAT",
            Header: "Fecha Respuesta",
            accessor: "fechaMensajeRespuestaSAT",
            width: 110
        }, {
            id: "exitoso",
            Header: "Exitoso",
            accessor: "exitoso",
            width: 60
        }, {
            id: "estado",
            Header: "Estado",
            accessor: "estado",
            width: 120
        }, {
            id: "motivoRechazo",
            Header: "Rechazo",
            accessor: "motivoRechazo",
            width: 70
        }];

    constructor(props: any) {
        super(props);

        this.state = {
            indiceDesplegado: undefined
        };
    }

    render() {
        const { respuestasTSAT, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (respuestasTSAT.length < tamanoPagina) {
            numRegistros = respuestasTSAT.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{respuestasTSAT.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={respuestasTSAT}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroConsultaHistoricoMsj = {
            fechaInicial: this.props.filtro.fechaInicial,
            fechaFinal: this.props.filtro.fechaFinal,
            listaServicios: this.props.filtro.listaServicios,
            dniEmpleador: this.props.filtro.dniEmpleador,
            poliza: this.props.filtro.poliza,
            codigoSede: this.props.filtro.codigoSede,
            codigoCentroTrabajo: this.props.filtro.codigoCentroTrabajo,
            dniEmpleado: this.props.filtro.dniEmpleado,
            periodo: this.props.filtro.periodo,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        return (
            <div style={{ marginTop: '10px' }}>
                <span>{props.value}</span>
            </div>
        );
    }

    renderDetalleJson = (props: any, stringJson: string, titulo: string) => {
        const subTitulo = `Consecutivo Proceso: # ${props.original.consecutivo}`;
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={titulo}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }
}

interface TablaHistoricoMensajesProps {
    respuestasTSAT: Array<HistoricoMensaje>
    filtro: FiltroConsultaHistoricoMsj,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroConsultaHistoricoMsj) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_tabla_historicos/componentes/TablaHistoricoMensajes.tsx